<template>
    <div :class="bgVariant">
        <div 
            class="py-1 px-3"
            :class="toggleClass"
        >
            <a
                href="#"
                :class="visible ? null : 'collapsed'"
                class="text-decoration-none font-weight-bold text-uppercase font-size-80"
                :aria-expanded="visible ? 'true' : 'false'"
                @click="visible = !visible"
            >
                {{ buttonText }}
                <span class="ml-2">
                    <b-icon :icon="visible ? 'chevron-up' : 'chevron-down'"></b-icon>
                </span>
                
            </a>
        </div>
        <b-collapse
            v-model="visible"
            :class="collapseClass"
        >
            <div class="mx-3 py-1">
                <slot>Default slot content</slot>
            </div>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'BaseSingleCollapse',
    props: {
        buttonVariant: {
            type: String,
            default: 'link'
        },
        buttonText: {
            type: String,
            default: 'Button Text'
        },
        bgVariant: {
            type: String,
            default: 'bg-light'
        },
        collapseClass: {
            type: String,
            default: '',
        },
        toggleClass: {
            type: String,
            default: '',
        },
        expanded: {  // if true, it will START expanded
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            visible: this.expanded,  // get initial value from prop
        }
    },
    computed: {},
    methods: {}
}
</script>

<style>

</style>